/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { Fragment } from 'react';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import DdfFieldArray from '@data-driven-forms/react-form-renderer/dist/cjs/field-array';

import { ItemArray } from './ItemArray';
import { AddButton } from '../AddButton';

export function FieldArray(props) {
  const { fieldKey, arrayValidator, title, description, fields, itemDefault, entityName, meta, label, ...rest } =
    useFieldApi(props);
  const { error } = meta;
  const isError = Boolean(error && error.length);
  const { canView = true, maxItems } = props;

  const addHandler = (fieldArrayRenderProps) => {
    return fieldArrayRenderProps.fields.push();
  };

  return (
    <Fragment>
      {canView ? (
        <DdfFieldArray key={fieldKey} name={rest.input.name} validate={arrayValidator}>
          {(fieldArrayRenderProps) => {
            let addButtonIsVisible = true;
            if (maxItems && fieldArrayRenderProps.fields) {
              const entries = fieldArrayRenderProps?.fields?.length;
              addButtonIsVisible = entries ? entries < maxItems : true;
            }
            return (
              <Fragment>
                {title && <h3 className='pt-8 pb-1 font-medium'>{title}</h3>}
                {description && <p>{description}</p>}
                {fieldArrayRenderProps.fields.map((name, index) => (
                  <ItemArray
                    key={`${name || fieldKey}-${index}`}
                    isError={isError}
                    fields={fields}
                    name={name}
                    entityName={entityName}
                    fieldIndex={index}
                    itemDefault={itemDefault}
                    isOnlyElement={fieldArrayRenderProps.fields.length === 1}
                    isLastElement={fieldArrayRenderProps.fields.length === index + 1}
                    remove={fieldArrayRenderProps.fields.remove}
                    push={fieldArrayRenderProps.fields.push}
                  />
                ))}
                {addButtonIsVisible && (
                  <AddButton
                    label={label || 'Add contacts'}
                    extraClass='-mt-10 p-0 border-none'
                    onClick={() => addHandler(fieldArrayRenderProps)}
                  />
                )}
              </Fragment>
            );
          }}
        </DdfFieldArray>
      ) : null}
    </Fragment>
  );
}
